<template>
  <footer class="bg-primary-600">
    <div
      class="lg:w-full max-w-7xl px-2 lg:px-4 mx-auto py-6 md:py-16 pt-14 md:pt-16 text-white"
    >
      <ProgramLists />

      <Divider
        class="before:border-t-[0.5px] before:border-surface-500 !my-10"
      />

      <UniversityLists />

      <Divider
        class="before:border-t-[0.5px] before:border-surface-500 !mt-10"
      />
    </div>
    <div
      class="lg:w-full max-w-7xl px-2 lg:px-4 mx-auto py-6 md:py-16 pt-4 md:pt-4 text-white"
    >
      <div class="grid grid-cols-1 md:grid-cols-9 md:gap-14 gap-8">
        <div class="col-span-1 md:col-span-3 px-2 lg:px-0">
          <img src="~/assets/img/logo-white.svg" class="max-w-[200px]" />
          <p class="text-sm text-white py-4 leading-6 tracking-wide">
            UniLinks is an education platform that helps students explore
            universities in Thailand, compare programs, and receive
            experience-based consultations enriched with real insights from
            students who have studied there.
          </p>
        </div>
        <div class="col-span-1 md:col-span-6">
          <div class="grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div class="space-y-4 px-2 lg:px-0">
              <p class="text-lg font-bold">Home</p>
              <NuxtLink
                to="/universities"
                class="text-sm cursor-pointer hover:underline block"
                >All Universities</NuxtLink
              >
              <NuxtLink
                to="/explore"
                class="text-sm cursor-pointer hover:underline block"
                >All Programs</NuxtLink
              >
              <NuxtLink
                to="/scholarships"
                class="text-sm cursor-pointer hover:underline block"
                >Scholarship</NuxtLink
              >
              <NuxtLink
                to="/ambassador"
                class="text-sm cursor-pointer hover:underline block"
                >Ambassadors</NuxtLink
              >
            </div>
            <div class="space-y-4 px-2 lg:px-0">
              <p class="text-lg font-bold">Resources</p>
              <NuxtLink
                to="/webinars"
                class="text-sm cursor-pointer hover:underline block"
                >Webinars</NuxtLink
              >
              <NuxtLink
                to="/blogs"
                class="text-sm cursor-pointer hover:underline block"
                >Blogs</NuxtLink
              >
            </div>
            <div class="space-y-4">
              <p class="text-lg font-bold 2 lg:px-0">Contact us</p>
              <a
                href="tel:+66930760414"
                class="text-sm px-2 lg:px-0 flex items-center gap-3 group"
              >
                <i class="pi pi-phone"></i>
                <span class="group-hover:underline">+66 9 30760414</span>
              </a>
              <a
                href="mailto:info@unilinks.co"
                class="text-sm px-2 lg:px-0 flex items-center gap-3 group"
              >
                <i class="pi pi-envelope"></i>
                <span class="group-hover:underline">info@unilinks.co</span>
              </a>
              <!-- social icons link -->
              <div class="flex gap-2 px-2 lg:px-0 mt-6">
                <Button
                  as="a"
                  href="https://www.facebook.com/unilinks.myanmar"
                  target="_blank"
                  rel="noopener"
                  icon="pi pi-facebook"
                  text
                  rounded
                  class="!text-white hover:!bg-primary-500"
                  aria-label="Facebook"
                  :pt="{
                    icon: 'text-[24px]',
                  }"
                />
                <Button
                  as="a"
                  href="https://www.instagram.com/unilinks_myanmar?igsh=MWM4YWViNGt6ZHNqeQ=="
                  target="_blank"
                  rel="noopener"
                  icon="pi pi-instagram"
                  text
                  rounded
                  class="!text-white hover:!bg-primary-500"
                  aria-label="Instagram"
                  :pt="{
                    icon: 'text-[24px]',
                  }"
                />
                <Button
                  as="a"
                  href="https://www.youtube.com/@UniLinksCompany"
                  target="_blank"
                  rel="noopener"
                  icon="pi pi-youtube"
                  text
                  rounded
                  class="!text-white hover:!bg-primary-500"
                  aria-label="YouTube"
                  :pt="{
                    icon: 'text-[24px]',
                  }"
                />
                <Button
                  as="a"
                  href="https://www.linkedin.com/company/unilinks-global"
                  target="_blank"
                  rel="noopener"
                  icon="pi pi-linkedin"
                  text
                  rounded
                  class="!text-white hover:!bg-primary-500"
                  aria-label="LinkedIn"
                  :pt="{
                    icon: 'text-[24px]',
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex justify-between flex-wrap items-center px-5 lg:px-0 text-sm text-primary-200 mt-8 md:mt-20"
      >
        <p>© {{ displayYear }} Unilinks. All rights reserved.</p>
        <div class="flex items-center space-x-3 text-primary-200 mt-2 md:mt-0">
          <NuxtLink
            to="/terms-conditions"
            class="hover:text-white transition-colors duration-200"
          >
            Terms & Conditions
          </NuxtLink>
          <span>|</span>
          <NuxtLink
            to="/privacypolicy"
            class="hover:text-white transition-colors duration-200"
          >
            Privacy Policy
          </NuxtLink>
        </div>
      </div>

      <!-- <p class="text-lg font-bold">Popular Programs</p>
  
      <div class="grid grid-cols-12 justify-between mt-8">
        <div
          v-for="index in 4"
          class="col-span-12 sm:col-span-6 md:col-span-3 space-y-4"
        >
          <Button
            label="Harbour.Space"
            link
            v-for="index in 10"
            class="text-sm block text-white"
          />
        </div>
      </div>
  
      <hr class="my-12" />
  
      <div class="flex flex-col sm:flex-row justify-between gap-10 my-12">
        <div class="w-full sm:w-2/6 lg:w-3/12">
          <Image :src="LogoLight" />
          <p class="text-sm text-gray-300 mt-4 pr-5">
            Rorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis. Class
            aptent taciti sociosqu.
          </p>
        </div>
  
        <div class="grid grid-cols-12 flex-1 gap-y-6">
          <div class="space-y-4 col-span-12 sm:col-span-6 lg:col-span-3">
            <h6 class="text-lg font-bold">Home</h6>
            <p>All university</p>
            <p>Scholarship</p>
            <p>Study aboard</p>
          </div>
          <div class="space-y-4 col-span-12 sm:col-span-6 lg:col-span-3">
            <h6 class="text-lg font-bold">Services</h6>
            <p>Admission counseling</p>
            <p>Visa service</p>
            <p>Health cover</p>
            <p>Accommodation option</p>
          </div>
          <div class="space-y-4 col-span-12 sm:col-span-6 lg:col-span-3">
            <h6 class="text-lg font-bold">Resources</h6>
            <p>Guide</p>
            <p>Webinars</p>
            <p>Blog</p>
          </div>
          <div class="space-y-4 col-span-12 sm:col-span-6 lg:col-span-3">
            <h6 class="text-lg font-bold">Contact us</h6>
            <div class="flex gap-6 items-center">
              <i class="pi pi-phone"></i>
              <p>+959 123 456 789</p>
            </div>
            <div class="flex gap-6 items-center">
              <i class="pi pi-envelope"></i>
              <p>unilinks123@gmail.com</p>
            </div>
            <div class="flex gap-2">
              <Button
                icon="pi pi-facebook"
                text
                rounded
                aria-label="facebook"
                :pt="{
                  icon: 'text-xl',
                }"
              />
              <Button
                icon="pi pi-instagram"
                text
                rounded
                aria-label="instagram"
                :pt="{
                  icon: 'text-xl',
                }"
              />
              <Button
                icon="pi pi-linkedin"
                text
                rounded
                aria-label="linkedin"
                :pt="{
                  icon: 'text-xl',
                }"
              />
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </footer>
</template>

<script setup>
import LogoLight from "~/assets/img/logo-white.svg";
const startYear = 2024;
const currentYear = new Date().getFullYear();
const displayYear =
  startYear === currentYear ? `${startYear}` : `${startYear}–${currentYear}`;
</script>
